import { useMemo } from 'react'

import config from '@config'
import useABTestValue from '@hooks/useABTestValue'

const {
  publication: { publication },
} = config

export type UseEnableEnhancedSearchPage = () => boolean

const useEnableEnhancedSearchPage: UseEnableEnhancedSearchPage = () => {
  const isEnabled = useABTestValue('enableEnhancedSearchPage') === 'active'

  return useMemo(() => {
    const isRomandie = publication === 'romandie'
    return !isRomandie && isEnabled
  }, [isEnabled])
}
export default useEnableEnhancedSearchPage
